import { TemplatePage } from './types';

const backToSchoolPage: TemplatePage = {
  header: {
    color: '#FCD06F',
    icon: 'images/video-templates/back-to-school.jpg',
    title: 'Back to School Video Templates',
    title_meta: '500+ Customizable Back To School Video Templates',
    description_meta:
      'Looking for an easily customizable catchy Back To School video template? Wave.video got you covered ' +
      'offering Promo videos, flash sale videos, irresistible offers, fun facts templates, and more. Check it ' +
      'out today!',
    description:
      'Each template is available in all popular formats including horizontal, square, and vertical. Bring ' +
      'Back to school campaign to a whole new level with fun and memorable videos. Create promotional content ' +
      'that your audience will love. '
  },
  footer: {
    category: 'back to school',
    description:
      'Wave.video’s rich collection of Back To School video template, offers you plenty of beautiful choices. ' +
      'Selecting and Customizing templates is easy and enjoyable. No previous experience required to create ' +
      'professionally-looking videos send videos in email, post on social media, or embed them in a blog or website.'
  },
  content: [
    {
      type: 'templates',
      title: 'Back to School Videos',
      search: {
        category: '/Holidays & Occasions/Back to School'
      }
    },
    {
      type: 'stocks',
      title: 'Back to school',
      search: {
        name: 'back to school'
      }
    },
    { type: 'calendar' }
  ]
};

export default backToSchoolPage;
